export const isWholeNumber = val => {
  if (val === null || val === undefined || val < 0) {
    return false;
  }
  return true;
};
